import { EModelName } from './model-name';
import mongoose, { InferSchemaType } from 'mongoose';
import { Document } from 'mongoose';

export enum E_AssistantActions {
  Archived = 'archived',
  Urgent = 'urgent',
  EmailSent = 'email-sent',
  EmailLabeled = 'email-labeled',
  CalendarEventCreated = 'calendar-event-created',
  MeetingPrepDone = 'meeting-prep-done',
  MeetingPrepScheduled = 'meeting-prep-scheduled',
  MeetingPrepSkipped = 'meeting-prep-skipped',
  MeetingPrepStarted = 'meeting-prep-started',
  PersonSearch = 'person-search',
  PodcastGenerated = 'podcast-generated',
  EmailDrafted = 'email-drafted',
  MeetingSummaryGenerated = 'meeting-summary-generated',
  TodoListCreated = 'todo-list-created',
  TodoListExpired = 'todo-list-expired',
}

export enum E_ServiceName {
  Email = 'email',
  Calendar = 'calendar',
  Todo = 'todo',
}

const AssistantActionsSchema = new mongoose.Schema({
  user: { type: mongoose.Schema.Types.ObjectId, ref: EModelName.USER },
  integrationId: { type: String },
  service: { type: String },
  serviceName: { type: String },
  actions: { type: [String] },
  reason: { type: String },
  category: { type: String },
  from: { type: String },
  to: { type: String },
  subject: { type: String },
  feedback: { type: String },
  created: { type: Date, default: Date.now() },
});


// Extract the base type from the schema
export type T_AssistantActionsBase = InferSchemaType<typeof AssistantActionsSchema>;

// Extend the base type with proper enum typing
export interface T_AssistantActions extends Omit<T_AssistantActionsBase, 'serviceName' | 'actions'> {
  serviceName: E_ServiceName;
  actions: E_AssistantActions[];
}

export type T_AssistantActionsDocument = T_AssistantActions &
  Document & {
    _id: string;
  };

export { AssistantActionsSchema };
